import React from 'react';
import FormItemContainerControl from './FormItemContainerControl';
import FormItemTable from '../FormItemTable';




export default class FormItemTableControl extends FormItemContainerControl
{
	constructor(menuItemId,formId,parent,xml,group,module,forLookup) {
		super(menuItemId,formId,parent,xml,group,module,forLookup);
		this.classAlias = "FormItemTableRowControl";
	}

	getProperty_Height()
	{
		return this.properties.Height;
    }
    
    getProperty_HorizontalAlignment()
    {
        return "center";//this.properties.HorizontalAlignment;
    }

	getStyle()
	{
		//对于Tab本身没有任何布局 所以只关心父级布局情况
		let parentLayout = this.parentXML.Properties.Layout.Value;
		//本身固定布局为flex 纵向 因为要布局下面的标签选项卡与内容区域 内容区域填充剩余空间
		let style = {
			borderCollapse:'collapse'
	    };
		
		//如果设置了Width或者Height属性 则按照属性设置 否则为百分百 与Flex版框架保持一致	   
		//但是存在其余控件包含tab而设置成百分百的情况 此情况在Flex版框架中也没有考虑 但是在实际
		//使用过程中并未提出此问题 所以暂不考虑
	    
	    if(parentLayout == "horizontal")
	    {
	    	let _width = this.xml.Properties.Width.Value;
	    	if(_width == undefined)
	    		_width = "";
			let flexGrow = 0;
			let fixedWidth = false;
			if(_width == "")// && !window.isPopUp && !window.isLookup)
			{
				flexGrow = 100;
			}
			else
			{
				let iex = _width.indexOf("%");
				if(iex!=-1)
				{
					flexGrow = _width.substring(0,iex);
					//20210413 支持直接填写百分比 不使用flexGrow代替
					style.width = _width;
				}
				
				if(iex==-1&&_width != "")
				{
					flexGrow = _width+"px";
					fixedWidth = true;
				}	
			}
			
			if(!fixedWidth)style["flexGrow"] = flexGrow; 

			let _height = this.xml.Properties.Height.Value;
			if(_height == undefined)
				_height = "";

			if(_height == "" && !window.isPopUp && !window.isLookup)
			{
				if(this.module.hasUpDownDataGrid)
				{
					let _containsMaxControl = this.containsMaxControlForHeight(this.xml);
				 	if(_containsMaxControl)_height = "100%";	
				}
				else
				{
					_height = "100%";
				}
				 
			}
			if(_height == "100%")
				style["alignSelf"] = "stretch";
			else if(_height.indexOf("%") != -1)
				style["height"] = _height;
			else if(_height != "")
				style["height"] = _height+"px";
	    }
	    else //vertical 暂不考虑absolute
	    {
	    	let _height = this.xml.Properties.Height.Value;
	    	if(_height==undefined)
	    		_height = "";
			let flexGrow = 0;
			let fixedHeight = false;

			flexGrow = 0;
			if(_height == "" && !window.isPopUp && !window.isLookup)
			{
				if(this.module.hasUpDownDataGrid)
				{
					let _containsMaxControl = this.containsMaxControlForHeight(this.xml);
					if(_containsMaxControl)flexGrow = 100;	
				}
				else
				{
					flexGrow = 100;
				}
				
			}
			else
			{
				let iex = _height.indexOf("%");
				if(iex!=-1)
				{
					flexGrow = _height.substring(0,iex);
					style.height = _height;
				}
				if(iex==-1&&_height != "")
				{
					flexGrow = _height+"px";
					fixedHeight = true;
				}	
			}
			
			if(!fixedHeight)style["flexGrow"] = flexGrow;
			else style["height"] = flexGrow;  

			let _width = this.xml.Properties.Width.Value;
			if(_width == undefined)
				_width = "";
			if(_width == "" && !window.isPopUp && !window.isLookup)
			{
				_width = "100%";
				 //let _containsMaxControl = this.containsMaxControlForWidth(this.xml);
				 //if(_containsMaxControl)_width = "100%";
			}
			if(_width == "100%")
				style["alignSelf"] = "stretch";
			else if(_width.indexOf("%") != -1)
				style["width"] = _width;
			else if(_width != "")
				style["width"] = _width+"px";
			else if(window.isPopUp)
				style["alignSelf"] = "stretch";
		}
		
		return style;
    }
    
    containsMaxControlForHeight(item)
    {
        return false;
    }

	getComponentInstance(parent,forLookup)
	{
		this.component = <FormItemTable key={this.xml.id} xml={this.xml} moduleInstanceId={this.module.instanceUUId} 
						control={this} forLookup={forLookup} groupAlias={this.groupAlias}
                        customStyle={this.getStyle()} formId={this.formId} menuItemId={this.menuItemId}
                        contextMenuData={this.contextMenuData} />;
		return this.component;
	}
}



// WEBPACK FOOTER //
// ./src/formItem/controls/FormItemTableControl.js